import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconTimeLater({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 534 586"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="evenodd">
				<path
					fill="#cd0400"
					d="M464.888 536.727H61.505c-23.643 0-42.42-19.708-41.037-43.09L42.93 112.582c1.27-21.556 19.288-38.395 41.082-38.395h357.902c21.76 0 39.744 16.805 41.014 38.327l22.486 381.646c1.372 23.098-17.168 42.568-40.527 42.568"
				/>
				<path
					fill="#fff"
					d="M444.491 516.53H41.12c-23.654 0-42.42-19.708-41.048-43.09L22.534 92.383C23.804 70.827 41.822 54 63.627 54h357.891c21.76 0 39.744 16.793 41.014 38.315l22.497 381.647c1.361 23.098-17.179 42.567-40.538 42.567"
				/>
				<g fillRule="nonzero">
					<path
						fill="#fff"
						d="M322.923 525.775v-57.53l.004-.307c.163-7.038 5.92-12.693 12.996-12.693l95.458-.001-12.835-27.825-.17-.387-.06-.145a11 11 0 0 1-.156-.396c-2.355-6.353.567-13.472 6.745-16.322a13 13 0 0 1 13.746 1.8l90.44 75.036.17.144.289.256q.166.15.326.306c4.833 4.72 5.252 12.378.92 17.6a13 13 0 0 1-1.704 1.704l-90.44 75.036-.173.14-.306.236a11 11 0 0 1-.36.264c-5.532 3.879-13.135 2.877-17.467-2.344l-.142-.175-.238-.308a11 11 0 0 1-.266-.363l-.204-.301a13 13 0 0 1-.95-12.6l12.835-27.827-95.457.002c-7.18 0-13-5.82-13-13"
					/>
					<path
						fill="#cd0400"
						d="M318.517 519.165v-57.53l.003-.306c.163-7.038 5.92-12.694 12.997-12.694h95.458l-12.836-27.826-.087-.193-.143-.339a11 11 0 0 1-.155-.396c-2.356-6.353.567-13.472 6.745-16.321a13 13 0 0 1 13.746 1.8l90.44 75.035.17.144.288.257q.167.15.326.305c4.834 4.72 5.253 12.378.92 17.6a13 13 0 0 1-1.704 1.704l-90.613 75.176-.305.236q-.178.136-.36.264c-5.532 3.879-13.136 2.877-17.468-2.344l-.142-.175-.237-.307a11 11 0 0 1-.266-.364l-.205-.3a13 13 0 0 1-.95-12.6l12.836-27.828-95.458.002c-7.18 0-13-5.82-13-13"
					/>
				</g>
				<g stroke="#cd0400" strokeLinecap="round" strokeWidth={11}>
					<path d="M73.5 188h339M73.5 262h339M73.5 336h339M73.5 410h339M246 158.415v281.17M364 158.415v281.17M122 158.415v281.17" />
				</g>
				<g fill="#cd0400">
					<rect width={44} height={88} x={111} rx={22} />
					<rect width={44} height={88} x={326} rx={22} />
				</g>
			</g>
		</svg>
	);
}
